import {getInternalClock} from '../../actions/InternalClockAction';

const RestClock = dispatch => {
  let device_time_stamp = new Date().getTime();
  fetch(`http://worldtimeapi.org/api/timezone/utc`)
    .then(c => c.json())
    .then(response => {
      let server_time_stamp = new Date(response?.datetime).getTime();
      let difference_time_stamp = server_time_stamp - device_time_stamp;
      dispatch(
        getInternalClock({
          difference_time_stamp: Number(difference_time_stamp),
        }),
      );
    })
    .catch(error => {
      console.log(error);
      dispatch(
        getInternalClock({
          difference_time_stamp: Number(0),
        }),
      );
    });
};

export default RestClock;
